import { Spinner } from '@si/components';
import { useUser } from '@si/hooks';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

export function AdminOnly({ children }: { children: ReactNode }) {
  const { user, isLoading } = useUser();
  if (isLoading) return <Spinner show />;
  if (!user?.isSiAdmin) return <Navigate to="/projects" replace />;
  return children;
}

export function LegacyAdminRedirect({ path }: { path: string }) {
  const { search, hash } = useLocation();
  return (
    <AdminOnly>
      <Navigate to={{ pathname: `/admin/${path}`, search, hash }} replace />
    </AdminOnly>
  );
}
